import { repositoryActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  list: [],
  selected: null
};

const repositoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_ALL_SUCCESS:
    case actionType.GET_USER_SUCCESS: {
      const { repositories } = action.payload;
      return {
        ...state,
        list: repositories,
      };
    }

    case actionType.GET_SUCCESS: {
      const { repository } = action.payload;
      return {
        ...state,
        selected: repository,
      };
    }

    case actionType.UPDATE_SUCCESS: {
      const { repository, successMsg } = action.payload;
      return {
        ...state,
        selected: repository,
        success: successMsg,
      };
    }

    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        error
      };
    }

    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        success: '',
        error: ''
      };
    }

    default: {
      return state;
    }
  }
};

export default repositoryReducer;
